import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '4rem 2rem', textAlign: 'center', maxWidth: '500px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '4rem', margin: '0', color: '#667eea' }}>404</h1>
      <h2 style={{ marginTop: '0.5rem', color: 'var(--color-text, #333)' }}>Page Not Found</h2>
      <p style={{ color: 'var(--color-text-secondary, #666)', marginBottom: '2rem' }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <button
        onClick={() => navigate('/')}
        style={{
          padding: '0.75rem 1.5rem',
          background: '#667eea',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '1rem'
        }}
      >
        Go to Dashboard
      </button>
    </div>
  );
}

export default NotFoundPage;
